export default {
	state: () => ({
		activeHighlight: null,
		isFirstInteraction: false,
		formKitSubmittedFormId: null,
		gtmFormName: null,
	}),
	getters: {
		getActiveHighlight: (state) => {
			return state.activeHighlight;
		},
		getIsFirstInteraction: (state) => {
			return state.isFirstInteraction;
		},
		getFormKitSubmittedFormId: (state) => {
			return state.formKitSubmittedFormId;
		},
		getGtmFormName: (state) => {
			return state.gtmFormName;
		}
	},
	mutations: {
		setActiveHighlight: (state, highlight) => {
			state.activeHighlight = highlight;
		},
		setIsFirstInteraction: (state, interaction) => {
			state.isFirstInteraction = interaction;
		},
		setFormKitSubmittedFormId: (state, id) => {
			state.formKitSubmittedFormId = id;
		},
		setGtmFormName: (state, name) => {
			state.gtmFormName = name;
		},
	},
};
